"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ExpenseCategory = void 0;
/**
 * Should only be used in the back-end
 */
var ExpenseCategory;
(function (ExpenseCategory) {
    ExpenseCategory[ExpenseCategory["EMPLOYEE"] = 0] = "EMPLOYEE";
    ExpenseCategory[ExpenseCategory["CONTRACTORS"] = 1] = "CONTRACTORS";
    ExpenseCategory[ExpenseCategory["CLOUD"] = 2] = "CLOUD";
    ExpenseCategory[ExpenseCategory["LEGAL"] = 3] = "LEGAL";
    ExpenseCategory[ExpenseCategory["SUPPLIES"] = 4] = "SUPPLIES";
})(ExpenseCategory || (exports.ExpenseCategory = ExpenseCategory = {}));
